import { render, staticRenderFns } from "./garbageStationSorterStatistics.vue?vue&type=template&id=2fbe50c4&scoped=true&"
import script from "./garbageStationSorterStatistics.vue?vue&type=script&lang=js&"
export * from "./garbageStationSorterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./garbageStationSorterStatistics.vue?vue&type=style&index=0&id=2fbe50c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe50c4",
  null
  
)

export default component.exports